import React, { Component } from "react";
import { modal } from "../modal";
import { openContact } from "../../common/callUtil"
//import { hideChat } from "../../lib/synalio";
import { MasterDataReady } from "../../lib/masterData/MasterDataReady";
import { isVisibleContent } from "../../common/DynamicContent";
import { Link } from "../../lib/Link";

export const modal_type_contact = props => {
  const { asset, room, eventTrackingId } = props;
  //hideChat();
  console.log(asset)
  return (
    <div className="modal_type_contact modal_base">
      <div className="cross" onClick={() => modal.closeModal()} />
      <div className="title">
        <span>お問い合わせの種類を</span>
        <span>選択して下さい</span>
      </div>
      <div className="collection">
        <a
          className="item link"
          onClick={e => {
            e.preventDefault();
            openContact("visitor_main", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          ご利用を検討中または<br />お申込み予定のお客様
        </a>
        <a
          className="item link"
          onClick={e => {
            e.preventDefault();
            modal.openModal("modal_type_contact_member", {
              asset,
              room,
              eventTrackingId,
            });
          }}
        >
          既にお申込み済みのお客様
        </a>
      </div>
      <MasterDataReady schemaIds={["excComment"]} render={() => {
        if (!isVisibleContent(masterData.excComment.modalOther)) {
          return <div className="collection_footer">
            <a
              className="item link"
              onClick={e => {
                e.preventDefault();
                modal.openModal("modal_type_contact_other", {
                  asset,
                  room,
                  eventTrackingId,
                });
              }}
            >
              上記以外のお問い合わせ
            </a>
          </div>
        } else {
          return null;
        }
      }}/>
    </div>
  );
};



// WEBPACK FOOTER //
// ./common/modal/modal_type_contact.jsx